import "../style/main.js"
import "../style/util.js"

import { injectGlobal } from "styled-components"

import { above } from '../style/functions'
import * as vars from "../style/vars"
import "../../static/fonts/stylesheet.css"

injectGlobal`
	*,::after,::before{margin:0;padding:0;border:0;border-collapse:collapse;border-spacing:0;box-sizing:border-box;outline:0;font:inherit;vertical-align:baseline;quotes:none}// HTML 5 me bro footer,header,hgroup,menu,nav,section,small{display:block}// No quotes,blockquote:after,please! blockquote:before,q:after,q:before{content:'';content:none}

	html {
		background-repeat: no-repeat;
		font-size: 12px;
		color: ${vars.colors.body};
		font-family: ${vars.fonts.main};
		line-height:1.5;
    letter-spacing:0.03rem;
		body.fixed {
			height: 100%;
			overflow: hidden;
		}
    ${above.desktop`
      font-size: 14px;
    `}
		${above.giant`
			font-size: 14px;
		`}
	}

`
